import React from 'react'
import './Footer.css'

const Footer = () => {
  return (
    <div className='footer'>
        <p>Copyright &copy; @jm3699</p>
    </div>
  )
}

export default Footer